"use client";

import React from "react";
import { Facebook, MessageCircle, Phone, Mail, MapPin, Clock, ArrowRight, ShieldCheck, Instagram, Youtube, Music2 } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const contactChannels = [{
  id: "instagram",
  icon: Instagram,
  label: "Instagram",
  value: "\n",
  color: "text-primary",
  url: "https://www.instagram.com/dishekimi_aysegulinneci/"
}, {
  id: "youtube",
  icon: Youtube,
  label: "YouTube",
  value: "\n",
  color: "text-primary",
  url: "https://www.youtube.com/channel/UCDPAN-oHd2_EaXAvgRmtBhA"
}, {
  id: "google",
  icon: Music2,
  label: "google",
  value: "\n",
  color: "text-primary",
  url: "https://share.google/aR2Nunp07lRA1kx6X"
}];
const quickStats = [{
  id: "response",
  label: "Deneyim",
  value: "8+ Yıl"
}, {
  id: "status",
  label: "Mutlu Gülüş",
  value: "10000+ Hasta"
}];
const detailedInfo = [{
  id: "location",
  icon: MapPin,
  label: "Klinik Adresi",
  value: "Melikgazi, Kayseri"
}, {
  id: "hours",
  icon: Clock,
  label: "Çalışma Saatleri",
  value: "09:00 - 19:00"
}];
export default function Contact() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169377" id="socialmedialinks" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div ref={leftColRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            {}
            <div className="relative rounded-sm overflow-hidden border border-primary/10 shadow-xl shadow-primary/5 group">
              <AspectRatio ratio={16 / 9}>
                
                <img src="https://dtaysegul.com/wp-content/uploads/2026/04/IMG_5666-scaled-e1776027694245.jpg" alt="Modern Dental Clinic" className="object-cover w-full h-full transition-transform duration-1000 group-hover:scale-105" />
                
                {}
                <div className="absolute top-4 left-4 z-20">
                  <Badge variant="default" className="bg-background/90 backdrop-blur-md text-primary border border-primary/20 px-4 py-2 shadow-sm">
                    <ShieldCheck className="w-4 h-4 mr-2" />
                    Lisanslı Diş Kliniği
                  </Badge>
                </div>
              </AspectRatio>
            </div>

            {}
            
          </div>

          {}
          <div ref={rightColRef} className={`flex flex-col gap-10 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="space-y-6">
              <h2 className="text-5xl md:text-7xl font-serif font-medium tracking-tight text-foreground leading-tight">
                Bizi <span className="text-primary italic">Takip Edin</span>
              </h2>
              <p className="text-lg text-muted-foreground max-w-md font-sans leading-relaxed">
                Siz de kusursuz bir gülüşe giden yolculuğumuzun bir parçası olun. Sosyal mecralarımızda güncel vaka paylaşımları ve ağız sağlığı ipuçlarını bulabilirsiniz.
              </p>
            </div>

            {}
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {quickStats.map((stat, i) => <div key={stat.id} data-index={i} className="rounded-sm bg-gradient-to-br from-primary/10 to-transparent p-[1px]">
                  <div className="h-full w-full rounded-sm bg-card/80 p-6 flex flex-col justify-center border border-primary/5">
                    <span className="text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2">
                      {stat.label}
                    </span>
                    <span className="text-2xl md:text-3xl font-serif text-foreground">
                      {stat.value}
                    </span>
                  </div>
                </div>)}
            </div>

            {}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {contactChannels.map((channel, i) => <Link key={channel.id} to={channel.url} newTab data-index={i} className="block">
                  <Card className="text-card-foreground flex flex-col gap-6 rounded-sm border-primary/10 bg-primary/10 transition-all duration-300 group shadow-sm py-0 !items-start hover:bg-primary/20 h-full">
                    <CardContent className="p-6 flex flex-col gap-4">
                      <channel.icon className={`w-5 h-5 ${channel.color} group-hover:scale-110 transition-transform`} />
                      <div className="space-y-1">
                        <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground">
                          {channel.label}
                        </p>
                        <p className="text-base font-serif text-foreground break-all">
                          {channel.value}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </Link>)}
              <Link to="https://www.facebook.com/dishekimiaysegulinneci?locale=tr_TR" newTab className="block">
                <Card className="rounded-sm border-primary/10 bg-primary/10 hover:bg-primary/20 transition-all duration-300 group shadow-sm py-0 h-full">
                  <CardContent className="p-6 flex flex-col gap-4">
                    <Facebook className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" />
                    <div className="space-y-1">
                      <p className="text-xs font-medium uppercase tracking-widest text-muted-foreground">
                        Facebook
                      </p>
                      <p className="text-base font-serif text-foreground break-all"><br /></p>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>

            {}
            
          </div>
        </div>
      </div>
    </section>;
}